<template>
  <section>
    <div>
      <h2 class="">{{ trainer.title }}</h2>
      <back v-if="status === 'init'"></back>
    </div>  

    <!-- настройки -->

    <div class="wh-block" v-show="status === 'init'">
      <Settings :trainer="trainer" @start="start" />
		</div>

    <!-- игра -->

		<Game 
      v-if="status === 'start'" 
      :params="params" 
      @stop="status = 'init'" 
      @show-result="showResult"
    />

    <!-- результат -->

    <div class="game" v-if="status === 'result'">
      <Result        
        :result="result"
        @again="start" 
        @stop="status = 'init'" 
      />
    </div>
  </section>
</template>

<script>
import { trainer_start_mix } from '../trainer_start_mix'
import Settings from './components/Settings.vue'
import Game from './components/Game.vue'
import Result from './components/Result.vue'

export default {  
  components: { Settings, Game, Result },
  mixins: [ trainer_start_mix ]
}
</script>